import React from "react";
import {
  getRiskClass,
  getRiskLabel,
  getPriorityClass,
  splitDriverSeverity,
  getSeverityClass,
} from "../../utils/riskUtils";
import "../../styles/aiEvaluation.scss";

// Presentational pieces of an AI risk summary, shared by the evaluation dialog
// and any page that shows the summary inline.

export function RiskBadge({ level }) {
  const label = getRiskLabel(level);
  if (!label) return null;
  return (
    <span className={`ai-eval-risk-badge ${getRiskClass(level)}`}>{label}</span>
  );
}

export function KeyDriversList({ drivers }) {
  if (!Array.isArray(drivers) || drivers.length === 0) return null;
  return (
    <ul className="ai-eval-drivers">
      {drivers.map((driver, idx) => {
        const { text, severity } = splitDriverSeverity(driver);
        const severityClass = getSeverityClass(severity);
        return (
          <li key={idx} className={severityClass}>
            <span className="ai-eval-driver-bullet" />
            <span className="ai-eval-driver-text">{text}</span>
            {severity && (
              <span className={`ai-eval-severity ${severityClass}`}>
                {severity}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
}

// A tag is a priority when it names one; anything else is the clinical area
// the action targets ("→ Cholesterol LDL").
const PRIORITY_TAG_RE = /critical|urgent|high|moderate|medium|low|priority|routine/i;

export function RecommendedActionsList({ actions }) {
  if (!Array.isArray(actions) || actions.length === 0) return null;
  return (
    <ul className="ai-eval-actions">
      {actions.map((action, idx) => {
        const tags = (action?.tags || []).filter(Boolean).map(String);
        const categories = tags.filter((t) => !PRIORITY_TAG_RE.test(t));
        const priorities = tags.filter((t) => PRIORITY_TAG_RE.test(t));
        return (
          <li key={idx}>
            <span className="ai-eval-action-bullet" />
            <span className="ai-eval-action-text">{action?.action}</span>
            {categories.map((c, ci) => (
              <span key={`c${ci}`} className="ai-eval-category-pill">
                → {c}
              </span>
            ))}
            {priorities.map((p, pi) => (
              <span
                key={`p${pi}`}
                className={`ai-eval-priority-pill ${getPriorityClass([p])}`}
              >
                {p}
              </span>
            ))}
          </li>
        );
      })}
    </ul>
  );
}
